export default __webpack_public_path__ + "static/media/949.300da4e2.jpg";